import { ThemeProvider } from "@emotion/react";
import {
  Box,
  BoxProps,
  Checkbox,
  CheckboxProps,
  createTheme,
} from "@mui/material";
import { SInputProps } from "components/parts";
import { STheme } from "components/styles";
import { useRecoilValue } from "recoil";
import { focusState } from "states";

/**
 * チェックボックス
 */

/**
 * プロパティ
 */
export type SCheckProps = Partial<CheckboxProps> &
  Pick<
    SInputProps,
    "focusId" | "label" | "index" | "formRef" | "disabled" | "align"
  > &
  Pick<BoxProps, "gridColumn" | "gridRow">;

export const SCheck = ({
  focusId,
  index,
  align,
  formRef,
  gridColumn,
  gridRow,
  ...props
}: SCheckProps): JSX.Element => {
  // フォーカス設定
  const { focusRef, move } = useRecoilValue(focusState(focusId ?? ""));

  return (
    <ThemeProvider theme={theme}>
      <Box gridColumn={gridColumn} gridRow={gridRow}>
        <Box display="flex" justifyContent={align}>
          <Checkbox
            {...props}
            inputRef={(element) => {
              formRef(element);
              focusRef(index, element);
            }}
            onKeyDown={(event) => {
              if (event.key === "Enter") event.preventDefault();
              props.onKeyDown?.call(this, event);
              move(index, event);
            }}
            inputProps={{ ...props.inputProps, tabIndex: index ?? -1 }}
          />
        </Box>
      </Box>
    </ThemeProvider>
  );
};

const theme = createTheme(
  {
    components: {
      MuiCheckbox: {
        styleOverrides: {
          root: {
            padding: 0,
          },
        },
      },
    },
  },
  { STheme }
);
